import React from 'react'

/**
 * The last thing between a thrown render error and a white page.
 *
 * A8: a payment page that goes blank after the card was submitted is the worst possible
 * failure. The payer does not know whether they have been charged, so they either try again
 * -- paying twice -- or phone the business, who cannot tell them either.
 *
 * Deliberately plain: no MUI, no theme, no translation. Those are exactly the things that may
 * have thrown, and a boundary that can itself fail is not a boundary. The wording is English
 * for the same reason; i18next may be the thing that is broken.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { failed: false }
  }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  componentDidCatch(error, info) {
    // No console.log of anything payment-shaped; this is the component tree, not the payload.
    if (window && window.console) {
      window.console.error('pay page render failed', error, info)
    }
  }

  render() {
    if (!this.state.failed) {
      return this.props.children
    }

    return (
      <div
        style={{
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
          maxWidth: 420,
          margin: '48px auto',
          padding: '0 16px',
          textAlign: 'center',
          color: '#1f2933',
        }}
      >
        <h2 style={{ fontSize: 20, marginBottom: 8 }}>Something went wrong</h2>
        {/* The sentence that matters. Everything else on this screen is secondary. */}
        <p style={{ margin: '0 0 16px', lineHeight: 1.5 }}>
          Your card has <strong>not</strong> been charged. Please reload this page and try again.
        </p>
        {this.props.phone && (
          <p style={{ margin: 0, color: '#52606d' }}>
            If it keeps happening, call {this.props.phone}.
          </p>
        )}
      </div>
    )
  }
}
